import { useContext } from "react";
import { Navigate } from "react-router-dom";
import CurrentUserContext from "../contexts/CurrentUserContext";

const PAYMENT_BLOCKED_REASONS = ["LICENSE_EXPIRED", "UNIT_LIMIT_EXCEEDED"];

export default function AccountPaymentRequired() {
  const { currentUser } = useContext(CurrentUserContext);
  const licenseStatus = currentUser?.licenseStatus;
  const isPaymentBlocked =
    licenseStatus?.isBlocked &&
    PAYMENT_BLOCKED_REASONS.includes(licenseStatus?.reason);

  if (!isPaymentBlocked) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      className="flex min-h-[calc(100vh-160px)] items-center justify-center"
      data-testid="account-payment-required-page"
    >
      <div className="w-full max-w-xl rounded-3xl bg-white px-8 py-10 text-center shadow-[0_20px_60px_rgba(16,24,40,0.08)] dark:bg-darkThemeModalBg">
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-theme">
          Account Payment Required
        </p>
        <h1 className="mt-4 text-3xl font-semibold leading-tight text-dark dark:text-white">
          Your license needs to be paid before you can access Nexus.
        </h1>
        <p className="mt-4 text-base leading-7 text-[#5F6368] dark:text-white/70">
          Please contact your account administrator to renew your license and restore access.
        </p>
      </div>
    </div>
  );
}
